<template>
    <UBadge :label="item.label" :color="item.color" :variant="item.variant ?? 'subtle'" :icon="item.icon" :size="size" />
</template>

<script lang="ts" setup>
    import type { TagItem } from '@/types/Common'

    /** The house status badge (vue-spec components.md): a TagItem drawn as a UBadge. */
    withDefaults(defineProps<{ item: TagItem, size?: 'xs' | 'sm' | 'md' | 'lg' }>(), { size: 'md' })
</script>
